import { ExpertFormStatus } from 'types'

import { ExpertFormSliceState } from './slice'

export const selectExpertForm: AppSelector<ExpertFormSliceState> = state =>
  state.expertForm

export const selectExpertFormStatus: AppSelector<ExpertFormStatus> = state =>
  selectExpertForm(state).formStatus
